import { gql, TypedDocumentNode } from "@apollo/client";

export type CareerConsultantSection = {
  id: string;
  name: string;
  legacyId: string | null;
};

export type MeCareerConsultantSectionsResponse = {
  me: { id: string } | null;
  careerConsultantSections: CareerConsultantSection[];
};

export const ME_CAREER_CONSULTANT_SECTIONS_QUERY: TypedDocumentNode<MeCareerConsultantSectionsResponse> = gql`
  query MeCareerConsultantSections {
    me {
      id
    }
    careerConsultantSections {
      id
      name
      legacyId
    }
  }
`;

export type QuickAddPersonProgramStatusNode = {
  pgaId: string;
  latestProgram: { status: string | null } | null;
};

export type QuickAddPersonProgramStatusResponse = {
  people: { nodes: QuickAddPersonProgramStatusNode[] } | null;
};

export type QuickAddPersonProgramStatusVariables = {
  input: { pgaIds: string[] };
  first: number;
};

export const QUICK_ADD_PERSON_PROGRAM_STATUS_QUERY: TypedDocumentNode<
  QuickAddPersonProgramStatusResponse,
  QuickAddPersonProgramStatusVariables
> = gql`
  query QuickAddPersonProgramStatus($input: BackofficeCRMPeopleInput!, $first: Int!) {
    people(first: $first, input: $input) {
      nodes {
        id
        pgaId
        latestProgram {
          id
          status
        }
      }
    }
  }
`;

export type MentionPersonEnrichmentNode = {
  id: string;
  pgaId: string;
  profilePhoto?: string | null;
  primaryFacility?: { id: string; name: string } | null;
  latestProgram?: {
    status?: string | null;
    band?: {
      createdReason?: string | null;
      classification?: { name?: string | null; description?: string | null } | null;
    } | null;
  } | null;
};

export type MentionPeopleEnrichmentResponse = {
  people: { nodes: MentionPersonEnrichmentNode[] };
};

export type MentionPeopleEnrichmentVariables = {
  input: { pgaIds: string[] };
  first: number;
};

export const MENTION_PEOPLE_ENRICHMENT_QUERY: TypedDocumentNode<
  MentionPeopleEnrichmentResponse,
  MentionPeopleEnrichmentVariables
> = gql`
  query MentionPeopleEnrichment($input: BackofficeCRMPeopleInput, $first: Int) {
    people(input: $input, first: $first) {
      nodes {
        id
        pgaId
        profilePhoto
        primaryFacility {
          id
          name
        }
        latestProgram {
          status
          band {
            createdReason
            classification {
              name
              description
            }
          }
        }
      }
    }
  }
`;
